export const SITE_NAME = 'ByggFynd';

export const DEFAULT_META_DESCRIPTION =
  'Köp byggmaterial och verktyg från svenska återförsäljare på ByggFynd. Jämför priser och kampanjer på en marknadsplats för proffs och hemmafixare.';

/**
 * Publik bas-URL för canonical, OG och JSON-LD.
 * Sätt REACT_APP_SITE_URL=https://din-domän.se i produktion om origin vid build skiljer sig.
 */
export function getSiteOrigin() {
  const env = (process.env.REACT_APP_SITE_URL || '').trim().replace(/\/$/, '');
  if (env) return env;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
}

export function truncateMeta(text, maxLen = 160) {
  if (!text || typeof text !== 'string') return '';
  const oneLine = text.replace(/\s+/g, ' ').trim();
  if (oneLine.length <= maxLen) return oneLine;
  return `${oneLine.slice(0, maxLen - 1).trim()}…`;
}

export function plainTextFromHtml(html) {
  if (!html) return '';
  return String(html)
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function formatPageTitle(pageTitle) {
  const t = (pageTitle || '').trim();
  if (!t) return SITE_NAME;
  if (t.endsWith(SITE_NAME) || t.includes(`| ${SITE_NAME}`)) return t;
  return `${t} | ${SITE_NAME}`;
}

export function buildProductJsonLd(product) {
  if (!product?.id) return null;
  const origin = getSiteOrigin();
  const canonicalUrl = origin ? `${origin}/produkt/${product.id}` : undefined;
  if (!canonicalUrl) return null;

  const images = (product.images || []).filter(Boolean);
  const inStock = (product.stock ?? 0) > 0;
  const availability = inStock
    ? 'https://schema.org/InStock'
    : 'https://schema.org/OutOfStock';

  const conditionMap = {
    new: 'https://schema.org/NewCondition',
    demo: 'https://schema.org/UsedCondition',
    defect: 'https://schema.org/UsedCondition',
  };
  const itemCondition =
    conditionMap[product.condition] || 'https://schema.org/NewCondition';

  const desc = truncateMeta(plainTextFromHtml(product.description), 8000);

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.title,
    description: desc || product.title,
    image: images.length ? images : undefined,
    sku: product.id,
    offers: {
      '@type': 'Offer',
      url: canonicalUrl,
      priceCurrency: 'SEK',
      price: String(product.price ?? ''),
      availability,
      itemCondition,
    },
  };
}

export function buildWebSiteJsonLd(origin) {
  if (!origin) return null;
  const base = origin.replace(/\/$/, '');
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: `${base}/`,
    description: DEFAULT_META_DESCRIPTION,
    inLanguage: 'sv-SE',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${base}/produkter?search={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };
}
